// removed by extract-text-webpack-plugin
module.exports = {"content-container":"_2nIA5Xi6SY47YWAVq6fVS7","content-wrapper":"_3Ve60TRLwKb1Fm1ghURabi","container":"_3h_uPesclx0hPMZkEjZ5Uq","disabled":"_23bKTPEqG_DDD2c17IXxVm"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MainLayout.mod.css
// module id = 1570
// module chunks = 0